<template>
  <VKGroup :group-id="$route.params.id" @vk-group-update="groupUpdate"></VKGroup>
</template>

<script>
import VKGroup from '@/components/integrations/vk/VKGroup'
export default {
  name: 'VKCreateEditGroup',
  components: { VKGroup },
  methods: {
    groupUpdate(group) {
      if (!this.$route.params.id) {
        this.$router.push({ name: 'vk_group_create_edit', params: { id: group.id } })
      }
    },
  },
}
</script>
